import { useAppSelector } from "@/redux/store/hooks";
const useAccessStatus = () => {
  const {
    state: projectState,
    visibilityMode,
    canContribute
  } = useAppSelector((state) => state.project.project);

  const place = useAppSelector((state) => state?.place.place);
  const { state: placesState } = place;
  const isToolArchived = placesState === "archived";
  const isProjectArchived = projectState === "archived";
  const isPanelled = visibilityMode === "Panelled";
  const voteConditions = [
    {
      condition: () => isProjectArchived || isToolArchived,
      toastTitle: "archivedError"
    },
    {
      condition: () => isPanelled && !canContribute,
      toastTitle: "notPartOfPannelledGroup"
    }
  ];

  for (const { condition, toastTitle } of voteConditions) {
    if (condition()) {
      return { accessStatus: false, toastTitle };
    }
  }
  return { accessStatus: true, toastTitle: "" };
};

export default useAccessStatus;
